export default {
	name: state => state.name,
	email: state => state.email,
	id: state => state.id,
	profilePicture: state => state.profilePicture,
	role: state => state.role
}